import request from '@/utils/request'

// 登录请求
export function login(data: { phone: string | number; password?: string; smsCode?: string }) {
  return request.post('/login/doLogin', data)
}

//发送短信验证码
export function sendSms(data: { phone: string | number }) {
  return request.post('/login/sendSms', data)
}

//获取当前登录用户信息
export function userInfoApi() {
  return request.get('/user/userInfo')
}
